import React, {useState} from 'react'
import {Col, Row} from 'styled-bootstrap-grid'

import {useCheckout} from 'src/context/CheckoutContext'

import {Button, UnderlineButton} from 'src/components/buttons'
import {H5, PSmall} from 'src/components/typography'
import Modal from 'src/components/common/Modal'

export default function EmptyCartButton(): JSX.Element {
  const [show, setShow] = useState(false)

  const {clearCart} = useCheckout()

  return (
    <>
      <UnderlineButton
        text="Eyða öllu úr körfu"
        onClick={() => setShow(true)}
      />

      <Modal show={show} setShow={setShow}>
        <H5 withGutter>
          Ertu viss um að þú viljir eyða öllum vörum úr körfunni?
        </H5>
        <PSmall color="black60" withGutter>
          Þú munt ekki geta tekið þessa aðgerð til baka.
        </PSmall>
        <Row>
          <Col sm={6}>
            <Button onClick={() => setShow(false)}>Hætta við</Button>
          </Col>
          <Col sm={6}>
            <Button
              outlined
              onClick={() => {
                clearCart()
                setShow(false)
              }}
            >
              Eyða öllu
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  )
}
